import * as THREE from 'three';

export const ORIENT_DEG = { 0: 0, 10: 180, 16: 90, 22: 270 };

export const CELL_RAW = 9.99;
export const GRID_SCALE = 0.75;
export const TRACK_WIDTH_SCALE = 1.14;

const _dummy = new THREE.Object3D();
const _cellCenter = new THREE.Vector3();

export const TRACK_CELLS = [
	[ -3, -3, 'track-corner',   16 ],
	[ -2, -3, 'track-straight', 22 ],
	[ -1, -3, 'track-straight', 22 ],
	[  0, -3, 'track-corner',    0 ],
	[ -3, -2, 'track-straight',  0 ],
	[  0, -2, 'track-straight',  0 ],
	[ -3, -1, 'track-corner',   10 ],
	[ -2, -1, 'track-corner',    0 ],
	[  0, -1, 'track-straight',  0 ],
	[ -2,  0, 'track-straight', 10 ],
	[  0,  0, 'track-finish',    0 ],
	[ -2,  1, 'track-straight', 10 ],
	[  0,  1, 'track-straight',  0 ],
	[ -2,  2, 'track-corner',   10 ],
	[ -1,  2, 'track-straight', 16 ],
	[  0,  2, 'track-corner',   22 ],
];

const DECO_CELLS = [
	[ -4, -2, 'decoration-tents', 10 ],
	[ -1, -4, 'decoration-tents', 22 ],
	[ -1,  1, 'decoration-tents', 22 ],
	[ -8, -9, 'decoration-forest', 0 ], [ -7, -9, 'decoration-forest', 0 ],
	[ -6, -9, 'decoration-forest', 0 ], [ -5, -9, 'decoration-forest', 0 ],
	[ -4, -9, 'decoration-forest', 0 ], [ -3, -9, 'decoration-forest', 0 ],
	[ -2, -9, 'decoration-forest', 0 ], [ -1, -9, 'decoration-forest', 0 ],
	[  0, -9, 'decoration-forest', 0 ], [  1, -9, 'decoration-forest', 0 ],
	[  2, -9, 'decoration-forest', 0 ],
	[ -8, -8, 'decoration-forest', 0 ], [ -7, -8, 'decoration-forest', 0 ],
	[ -6, -8, 'decoration-forest', 0 ], [ -5, -8, 'decoration-forest', 0 ],
	[ -4, -8, 'decoration-forest', 0 ], [ -3, -8, 'decoration-forest', 0 ],
	[ -2, -8, 'decoration-forest', 0 ], [ -1, -8, 'decoration-forest', 0 ],
	[  0, -8, 'decoration-forest', 0 ], [  1, -8, 'decoration-forest', 0 ],
	[  2, -8, 'decoration-forest', 0 ],
	[ -8, -7, 'decoration-forest', 0 ], [ -7, -7, 'decoration-forest', 0 ],
	[ -6, -7, 'decoration-forest', 0 ], [ -5, -7, 'decoration-forest', 0 ],
	[ -4, -7, 'decoration-forest', 0 ], [ -3, -7, 'decoration-forest', 0 ],
	[ -2, -7, 'decoration-forest', 0 ], [ -1, -7, 'decoration-forest', 0 ],
	[  0, -7, 'decoration-forest', 0 ], [  1, -7, 'decoration-forest', 0 ],
	[  2, -7, 'decoration-forest', 0 ],
	[ -8, -6, 'decoration-forest', 0 ], [ -7, -6, 'decoration-forest', 0 ],
	[ -6, -6, 'decoration-forest', 0 ], [ -5, -6, 'decoration-forest', 0 ],
	[ -4, -6, 'decoration-forest', 0 ], [ -3, -6, 'decoration-empty', 0 ],
	[ -2, -6, 'decoration-empty', 0 ],  [ -1, -6, 'decoration-empty', 0 ],
	[  0, -6, 'decoration-empty', 0 ],  [  1, -6, 'decoration-forest', 0 ],
	[  2, -6, 'decoration-forest', 0 ],
	[ -8, -5, 'decoration-forest', 0 ], [ -7, -5, 'decoration-forest', 0 ],
	[ -6, -5, 'decoration-forest', 0 ], [ -5, -5, 'decoration-forest', 0 ],
	[ -4, -5, 'decoration-empty', 0 ],  [ -3, -5, 'decoration-empty', 0 ],
	[ -2, -5, 'decoration-empty', 0 ],  [ -1, -5, 'decoration-empty', 0 ],
	[  0, -5, 'decoration-empty', 0 ],  [  1, -5, 'decoration-forest', 0 ],
	[  2, -5, 'decoration-forest', 0 ],
	[ -8, -4, 'decoration-forest', 0 ], [ -7, -4, 'decoration-forest', 0 ],
	[ -6, -4, 'decoration-forest', 0 ], [ -5, -4, 'decoration-forest', 0 ],
	[ -4, -4, 'decoration-empty', 0 ],
	[  1, -4, 'decoration-forest', 0 ],
	[  2, -4, 'decoration-forest', 0 ],
	[ -8, -3, 'decoration-forest', 0 ], [ -7, -3, 'decoration-forest', 0 ],
	[ -6, -3, 'decoration-forest', 0 ], [ -5, -3, 'decoration-forest', 0 ],
	[ -4, -3, 'decoration-empty', 0 ],
	[  1, -3, 'decoration-forest', 0 ],
	[  2, -3, 'decoration-forest', 0 ],
	[ -8, -2, 'decoration-forest', 0 ], [ -7, -2, 'decoration-forest', 0 ],
	[ -6, -2, 'decoration-forest', 0 ], [ -5, -2, 'decoration-forest', 0 ],
	[  1, -2, 'decoration-forest', 0 ],
	[  2, -2, 'decoration-forest', 0 ],
	[ -8, -1, 'decoration-forest', 0 ], [ -7, -1, 'decoration-forest', 0 ],
	[ -6, -1, 'decoration-forest', 0 ], [ -5, -1, 'decoration-forest', 0 ],
	[ -4, -1, 'decoration-empty', 0 ],  [ -1, -1, 'decoration-empty', 0 ],
	[  1, -1, 'decoration-forest', 0 ],
	[  2, -1, 'decoration-forest', 0 ],
	[ -8,  0, 'decoration-forest', 0 ], [ -7,  0, 'decoration-forest', 0 ],
	[ -6,  0, 'decoration-forest', 0 ], [ -5,  0, 'decoration-forest', 0 ],
	[ -4,  0, 'decoration-empty', 0 ],  [ -3,  0, 'decoration-empty', 0 ],
	[ -1,  0, 'decoration-empty', 0 ],
	[  1,  0, 'decoration-forest', 0 ],
	[  2,  0, 'decoration-forest', 0 ],
	[ -8,  1, 'decoration-forest', 0 ], [ -7,  1, 'decoration-forest', 0 ],
	[ -6,  1, 'decoration-forest', 0 ], [ -5,  1, 'decoration-forest', 0 ],
	[ -4,  1, 'decoration-empty', 0 ],  [ -3,  1, 'decoration-empty', 0 ],
	[  1,  1, 'decoration-forest', 0 ],
	[  2,  1, 'decoration-forest', 0 ],
	[ -8,  2, 'decoration-forest', 0 ], [ -7,  2, 'decoration-forest', 0 ],
	[ -6,  2, 'decoration-forest', 0 ], [ -5,  2, 'decoration-forest', 0 ],
	[ -4,  2, 'decoration-empty', 0 ],  [ -3,  2, 'decoration-empty', 0 ],
	[  1,  2, 'decoration-forest', 0 ],
	[  2,  2, 'decoration-forest', 0 ],
	[ -8,  3, 'decoration-forest', 0 ], [ -7,  3, 'decoration-forest', 0 ],
	[ -6,  3, 'decoration-forest', 0 ], [ -5,  3, 'decoration-forest', 0 ],
	[ -4,  3, 'decoration-forest', 0 ], [ -3,  3, 'decoration-forest', 0 ],
	[ -2,  3, 'decoration-forest', 0 ], [ -1,  3, 'decoration-forest', 0 ],
	[  0,  3, 'decoration-forest', 0 ], [  1,  3, 'decoration-forest', 0 ],
	[  2,  3, 'decoration-forest', 0 ],
	[ -8,  4, 'decoration-forest', 0 ], [ -7,  4, 'decoration-forest', 0 ],
	[ -6,  4, 'decoration-forest', 0 ], [ -5,  4, 'decoration-forest', 0 ],
	[ -4,  4, 'decoration-forest', 0 ], [ -3,  4, 'decoration-forest', 0 ],
	[ -2,  4, 'decoration-forest', 0 ], [ -1,  4, 'decoration-forest', 0 ],
	[  0,  4, 'decoration-forest', 0 ], [  1,  4, 'decoration-forest', 0 ],
	[  2,  4, 'decoration-forest', 0 ],
];

const NPC_TRUCKS = [
	[ 'vehicle-truck-green',  -3.51, -0.01,  12.70,  98.0 ],
	[ 'vehicle-truck-purple', -23.78, -0.14, -13.56,   0.0 ],
	[ 'vehicle-truck-red',    -1.36, -0.15, -23.80, 155.9 ],
];

function getCellCenterRaw( gx, gz ) {

	return _cellCenter.set( ( gx + 0.5 ) * CELL_RAW, 0, ( gz + 0.5 ) * CELL_RAW );

}

function createGlowStrip( width, length, color, opacity = 0.45 ) {

	const glow = new THREE.Mesh(
		new THREE.PlaneGeometry( width, length ),
		new THREE.MeshBasicMaterial( {
			color,
			transparent: true,
			opacity,
			blending: THREE.AdditiveBlending,
			depthWrite: false,
			side: THREE.DoubleSide,
		} )
	);
	glow.rotation.x = - Math.PI / 2;
	return glow;

}

function addBridgeWaterway( parent, spec ) {

	const from = spec.from;
	const to = spec.to;
	const dx = Math.sign( to[ 0 ] - from[ 0 ] );
	const dz = Math.sign( to[ 1 ] - from[ 1 ] );
	const spanCells = Math.abs( to[ 0 ] - from[ 0 ] ) + Math.abs( to[ 1 ] - from[ 1 ] ) + 1;
	const angle = Math.atan2( dx, dz );

	const start = getCellCenterRaw( from[ 0 ], from[ 1 ] );
	const end = getCellCenterRaw( to[ 0 ], to[ 1 ] );

	const group = new THREE.Group();
	group.position.set( ( start.x + end.x ) * 0.5, 0, ( start.z + end.z ) * 0.5 );
	group.rotation.y = angle;

	const color = spec.color || 0x2fd6ff;
	const waterWidth = CELL_RAW * ( spec.waterWidth || 2.6 );
	const waterLength = spanCells * CELL_RAW + CELL_RAW * 0.8;
	const deckLength = spanCells * CELL_RAW + CELL_RAW * 0.18;

	const water = new THREE.Mesh(
		new THREE.PlaneGeometry( waterWidth, waterLength ),
		new THREE.MeshStandardMaterial( {
			color: 0x0f6f8b,
			emissive: color,
			emissiveIntensity: 0.28,
			metalness: 0.08,
			roughness: 0.16,
			transparent: true,
			opacity: 0.88,
		} )
	);
	water.rotation.x = - Math.PI / 2;
	water.position.y = - 2.8;
	group.add( water );

	const wake = createGlowStrip( waterWidth * 0.92, waterLength * 0.95, color, 0.3 );
	wake.position.y = - 2.72;
	group.add( wake );

	const bankMat = new THREE.MeshStandardMaterial( {
		color: 0x1f2734,
		emissive: color,
		emissiveIntensity: 0.05,
		metalness: 0.28,
		roughness: 0.52,
	} );
	for ( const side of [ - 1, 1 ] ) {

		const bank = new THREE.Mesh( new THREE.BoxGeometry( 0.9, 2.4, waterLength ), bankMat );
		bank.position.set( side * ( waterWidth * 0.5 + 0.48 ), - 1.55, 0 );
		group.add( bank );

		const rail = new THREE.Mesh(
			new THREE.BoxGeometry( 0.16, 0.34, deckLength ),
			new THREE.MeshStandardMaterial( {
				color: side < 0 ? 0xff4fd8 : 0x5cfbff,
				emissive: side < 0 ? 0xff4fd8 : 0x5cfbff,
				emissiveIntensity: 0.55,
				metalness: 0.32,
				roughness: 0.24,
			} )
		);
		rail.position.set( side * 3.55, 0.98, 0 );
		group.add( rail );

		const railGlow = createGlowStrip( 0.3, deckLength, side < 0 ? 0xff4fd8 : 0x5cfbff, 0.3 );
		railGlow.position.set( side * 3.28, 0.62, 0 );
		group.add( railGlow );

	}

	const pylonCount = Math.max( 2, Math.floor( spanCells / 2 ) + 1 );
	const pylonGeom = new THREE.BoxGeometry( 0.8, 2.8, 0.8 );
	const pylonMat = new THREE.MeshStandardMaterial( {
		color: 0xcfd8e3,
		emissive: color,
		emissiveIntensity: 0.08,
		metalness: 0.38,
		roughness: 0.34,
	} );
	for ( let i = 0; i < pylonCount; i ++ ) {

		const z = - waterLength * 0.45 + ( i / Math.max( 1, pylonCount - 1 ) ) * waterLength * 0.9;
		for ( const side of [ - 1, 1 ] ) {

			const pylon = new THREE.Mesh( pylonGeom, pylonMat );
			pylon.position.set( side * ( waterWidth * 0.5 - 0.5 ), - 1.35, z );
			group.add( pylon );

		}

	}

	parent.add( group );

}

function addNeonTunnel( parent, spec ) {

	const from = spec.from;
	const to = spec.to;
	const dx = Math.sign( to[ 0 ] - from[ 0 ] );
	const dz = Math.sign( to[ 1 ] - from[ 1 ] );
	const spanCells = Math.abs( to[ 0 ] - from[ 0 ] ) + Math.abs( to[ 1 ] - from[ 1 ] ) + 1;
	const angle = Math.atan2( dx, dz );

	const start = getCellCenterRaw( from[ 0 ], from[ 1 ] );
	const end = getCellCenterRaw( to[ 0 ], to[ 1 ] );

	const group = new THREE.Group();
	group.position.set( ( start.x + end.x ) * 0.5, 0, ( start.z + end.z ) * 0.5 );
	group.rotation.y = angle;

	const color = spec.color || 0xff4fd8;
	const frameMat = new THREE.MeshStandardMaterial( {
		color: 0xdce7ff,
		emissive: color,
		emissiveIntensity: 0.35,
		metalness: 0.24,
		roughness: 0.28,
	} );
	const frameStep = CELL_RAW * 0.9;
	const totalLength = ( spanCells - 1 ) * CELL_RAW;

	for ( let i = 0; i < spanCells; i ++ ) {

		const z = - totalLength * 0.5 + i * frameStep;
		const arch = new THREE.Group();

		const left = new THREE.Mesh( new THREE.BoxGeometry( 0.18, 3.3, 0.18 ), frameMat );
		left.position.set( - 3.4, 1.6, 0 );
		arch.add( left );

		const right = left.clone();
		right.position.x = 3.4;
		arch.add( right );

		const top = new THREE.Mesh( new THREE.BoxGeometry( 6.98, 0.18, 0.18 ), frameMat );
		top.position.set( 0, 3.18, 0 );
		arch.add( top );

		const glow = createGlowStrip( 6.6, 0.5, color, 0.24 );
		glow.rotation.x = - Math.PI / 2;
		glow.position.set( 0, 0.08, 0 );
		arch.add( glow );

		arch.position.z = z;
		group.add( arch );

	}

	parent.add( group );

}

function addBumpVisuals( parent, cells ) {

	const ringGeom = new THREE.TorusGeometry( 2.9, 0.16, 10, 32 );
	const cyanMat = new THREE.MeshStandardMaterial( {
		color: 0x8ef8ff,
		emissive: 0x33e6ff,
		emissiveIntensity: 0.9,
		metalness: 0.18,
		roughness: 0.22,
	} );
	const magentaMat = new THREE.MeshStandardMaterial( {
		color: 0xffb8f2,
		emissive: 0xff4fd8,
		emissiveIntensity: 0.7,
		metalness: 0.18,
		roughness: 0.24,
	} );

	for ( const [ gx, gz, key, orient ] of cells ) {

		if ( key !== 'track-bump' ) continue;

		const center = getCellCenterRaw( gx, gz );
		const deg = ORIENT_DEG[ orient ] ?? 0;
		const ring = new THREE.Mesh( ringGeom, cyanMat );
		ring.position.set( center.x, 3.3, center.z );
		ring.rotation.y = THREE.MathUtils.degToRad( deg );
		parent.add( ring );

		const halo = createGlowStrip( 4.6, 8.2, 0xff4fd8, 0.22 );
		halo.position.set( center.x, 0.12, center.z );
		halo.rotation.y = THREE.MathUtils.degToRad( deg );
		parent.add( halo );

		const sideBarGeom = new THREE.BoxGeometry( 0.22, 1.8, 0.22 );
		for ( const side of [ - 1, 1 ] ) {

			const bar = new THREE.Mesh( sideBarGeom, side < 0 ? magentaMat : cyanMat );
			bar.position.set( center.x + side * 3.05, 1.15, center.z );
			bar.rotation.y = THREE.MathUtils.degToRad( deg );
			parent.add( bar );

		}

	}

}

function addTrackSetpieces( parent, cells, setpieces ) {

	addBumpVisuals( parent, cells );

	if ( ! setpieces || setpieces.length === 0 ) return;

	for ( const spec of setpieces ) {

		if ( spec.type === 'bridge-waterway' ) {

			addBridgeWaterway( parent, spec );

		} else if ( spec.type === 'neon-tunnel' ) {

			addNeonTunnel( parent, spec );

		}

	}

}

export function buildTrack( scene, models, customCells, options = {} ) {

	const trackGroup = new THREE.Group();
	trackGroup.position.y = -0.5;

	const trackPieceGroup = new THREE.Group();
	const decoGroup = new THREE.Group();

	const cells = customCells || TRACK_CELLS;

	for ( const [ gx, gz, key, orient ] of cells ) {

		const piece = placePiece( models, key, gx, gz, orient );
		if ( piece ) trackPieceGroup.add( piece );

	}

	{

		const occupied = new Set();
		let minX = Infinity, maxX = - Infinity;
		let minZ = Infinity, maxZ = - Infinity;

		for ( const [ gx, gz ] of cells ) {

			occupied.add( gx + ',' + gz );
			minX = Math.min( minX, gx );
			maxX = Math.max( maxX, gx );
			minZ = Math.min( minZ, gz );
			maxZ = Math.max( maxZ, gz );

		}

		const emptyPositions = [];
		const forestPositions = [];
		const tentPositions = [];
		const buckets = {
			'decoration-empty': emptyPositions,
			'decoration-forest': forestPositions,
			'decoration-tents': tentPositions,
		};

		if ( ! customCells ) {

			for ( const [ gx, gz, key, orient ] of DECO_CELLS ) {

				occupied.add( gx + ',' + gz );
				minX = Math.min( minX, gx );
				maxX = Math.max( maxX, gx );
				minZ = Math.min( minZ, gz );
				maxZ = Math.max( maxZ, gz );

				const x = ( gx + 0.5 ) * CELL_RAW;
				const z = ( gz + 0.5 ) * CELL_RAW;
				const rotQ = ( ( ORIENT_DEG[ orient ] ?? 0 ) / 90 ) | 0;
				buckets[ key ]?.push( x, z, rotQ );

			}

		}

		const pad = 3;

		// Simple hash for deterministic pseudo-random placement
		function hash( gx, gz ) {

			let h = gx * 374761393 + gz * 668265263;
			h = ( h ^ ( h >> 13 ) ) * 1274126177;
			return ( h ^ ( h >> 16 ) ) >>> 0;

		}

		for ( let gz = minZ - pad; gz <= maxZ + pad; gz ++ ) {

			for ( let gx = minX - pad; gx <= maxX + pad; gx ++ ) {

				if ( occupied.has( gx + ',' + gz ) ) continue;

				const distX = gx < minX ? minX - gx : gx > maxX ? gx - maxX : 0;
				const distZ = gz < minZ ? minZ - gz : gz > maxZ ? gz - maxZ : 0;
				const dist = Math.max( distX, distZ );

				const x = ( gx + 0.5 ) * CELL_RAW;
				const z = ( gz + 0.5 ) * CELL_RAW;

				if ( dist <= 1 ) {

					// ~15% chance of tents in the empty ring
					if ( hash( gx, gz ) % 7 === 0 ) {

						tentPositions.push( x, z, hash( gx, gz ) % 4 );

					} else {

						emptyPositions.push( x, z, 0 );

					}

				} else {

					forestPositions.push( x, z, 0 );

				}

			}

		}

		function createInstances( src, positions ) {

			if ( positions.length === 0 || ! src ) return;

			const count = positions.length / 3;

			src.traverse( ( child ) => {

				if ( ! child.isMesh ) return;

				const inst = new THREE.InstancedMesh( child.geometry, child.material, count );
				inst.castShadow = true;
				inst.receiveShadow = true;

				for ( let i = 0; i < count; i ++ ) {

					_dummy.position.set( positions[ i * 3 ], 0.5, positions[ i * 3 + 1 ] );
					_dummy.rotation.y = positions[ i * 3 + 2 ] * Math.PI / 2;
					_dummy.updateMatrix();
					inst.setMatrixAt( i, _dummy.matrix );

				}

				decoGroup.add( inst );

			} );

		}

		createInstances( models[ 'decoration-empty' ], emptyPositions );
		createInstances( models[ 'decoration-forest' ], forestPositions );
		createInstances( models[ 'decoration-tents' ], tentPositions );

	}

	addTrackSetpieces( trackGroup, cells, options.setpieces );

	trackGroup.add( trackPieceGroup );
	trackGroup.add( decoGroup );

	trackGroup.scale.setScalar( 0.75 );
	scene.add( trackGroup );

	trackGroup.updateMatrixWorld( true );

	trackGroup.traverse( ( child ) => {

		if ( child.isMesh ) {

			child.castShadow = true;
			child.receiveShadow = true;

		}

	} );

	if ( ! customCells ) {

		for ( const [ key, x, y, z, rotDeg ] of NPC_TRUCKS ) {

			const src = models[ key ];
			if ( ! src ) continue;

			const npc = src.clone();
			npc.position.set( x, y, z );
			npc.rotation.y = THREE.MathUtils.degToRad( rotDeg + 180 );
			npc.traverse( ( c ) => {

				if ( c.isMesh ) {

					c.castShadow = true;
					c.receiveShadow = true;

				}

			} );
			scene.add( npc );

		}

	}

}

export function getBumpPads( cells = TRACK_CELLS ) {

	const scale = CELL_RAW * GRID_SCALE;

	return cells
		.filter( ( [ , , key ] ) => key === 'track-bump' )
		.map( ( [ gx, gz, , orient ] ) => {

			const deg = ORIENT_DEG[ orient ] ?? 0;
			const rad = THREE.MathUtils.degToRad( deg );

			return {
				key: `${ gx },${ gz }`,
				center: new THREE.Vector3( ( gx + 0.5 ) * scale, 0, ( gz + 0.5 ) * scale ),
				forward: new THREE.Vector3( Math.sin( rad ), 0, Math.cos( rad ) ),
				right: new THREE.Vector3( Math.cos( rad ), 0, - Math.sin( rad ) ),
				halfWidth: scale * 0.42,
				entry: scale * 0.45,
				exit: scale * 0.18,
			};

		} );

}

export function placePiece( models, key, gx, gz, orient ) {

	const src = models[ key ];
	if ( ! src ) return null;

	const piece = src.clone();
	piece.position.set( ( gx + 0.5 ) * CELL_RAW, 0.5, ( gz + 0.5 ) * CELL_RAW );

	const deg = ORIENT_DEG[ orient ] ?? 0;
	piece.rotation.y = THREE.MathUtils.degToRad( deg );

	if ( key === 'track-straight' || key === 'track-finish' || key === 'track-bump' ) {

		// Straight-style pieces are authored to run along local Z, so widening the
		// local X axis makes the road broader without lengthening the segment.
		piece.scale.x = TRACK_WIDTH_SCALE;

	} else if ( key === 'track-corner' ) {

		// Corners need a little extra room in both axes so the widened entry/exit
		// matches the adjacent straights.
		piece.scale.set( TRACK_WIDTH_SCALE, 1, TRACK_WIDTH_SCALE );

	}

	return piece;

}

// ─── Track Codec ──────────────────────────────────────────

const TYPE_NAMES = [ 'track-straight', 'track-corner', 'track-bump', 'track-finish' ];
const TYPE_INDEX = {};
for ( let i = 0; i < TYPE_NAMES.length; i ++ ) TYPE_INDEX[ TYPE_NAMES[ i ] ] = i;

const ORIENT_TO_GODOT = [ 0, 16, 10, 22 ];
const GODOT_TO_ORIENT = { 0: 0, 16: 1, 10: 2, 22: 3 };

export { TYPE_NAMES };

export function encodeCells( cells ) {

	const bytes = new Uint8Array( cells.length * 3 );

	for ( let i = 0; i < cells.length; i ++ ) {

		const [ gx, gz, name, godotOrient ] = cells[ i ];
		const ti = TYPE_INDEX[ name ] ?? 0;
		const oi = GODOT_TO_ORIENT[ godotOrient ] ?? 0;

		bytes[ i * 3 ] = gx + 128;
		bytes[ i * 3 + 1 ] = gz + 128;
		bytes[ i * 3 + 2 ] = ( ti << 2 ) | oi;

	}

	return bytesToBase64url( bytes );

}

export function decodeCells( str ) {

	const bytes = base64urlToBytes( str );
	const cells = [];

	for ( let i = 0; i + 2 < bytes.length; i += 3 ) {

		const gx = bytes[ i ] - 128;
		const gz = bytes[ i + 1 ] - 128;
		const packed = bytes[ i + 2 ];
		const ti = ( packed >> 2 ) & 0x03;
		const oi = packed & 0x03;

		cells.push( [ gx, gz, TYPE_NAMES[ ti ], ORIENT_TO_GODOT[ oi ] ] );

	}

	return cells;

}

export function computeSpawnPosition( cells ) {

	let cell = cells[ 0 ];

	for ( const c of cells ) {

		if ( c[ 2 ] === 'track-finish' ) {

			cell = c;
			break;

		}

	}

	if ( ! cell ) return { position: [ 3.5, 0.5, 5 ], angle: 0 };

	const gx = cell[ 0 ];
	const gz = cell[ 1 ];
	const x = ( gx + 0.5 ) * CELL_RAW * GRID_SCALE;
	const z = ( gz + 0.5 ) * CELL_RAW * GRID_SCALE;

	const orient = cell[ 3 ];
	const angle = THREE.MathUtils.degToRad( ORIENT_DEG[ orient ] || 0 );

	return { position: [ x, 0.5, z ], angle };

}

export function computeTrackBounds( cells ) {

	if ( ! cells || cells.length === 0 ) return { centerX: 0, centerZ: 0, halfWidth: 30, halfDepth: 30 };

	let minX = Infinity, maxX = - Infinity;
	let minZ = Infinity, maxZ = - Infinity;

	for ( const [ gx, gz ] of cells ) {

		minX = Math.min( minX, gx );
		maxX = Math.max( maxX, gx );
		minZ = Math.min( minZ, gz );
		maxZ = Math.max( maxZ, gz );

	}

	const S = CELL_RAW * GRID_SCALE;
	const centerX = ( minX + maxX + 1 ) / 2 * S;
	const centerZ = ( minZ + maxZ + 1 ) / 2 * S;
	const halfWidth = ( maxX - minX + 1 ) / 2 * S + S;
	const halfDepth = ( maxZ - minZ + 1 ) / 2 * S + S;

	return { centerX, centerZ, halfWidth, halfDepth };

}

function bytesToBase64url( bytes ) {

	let binary = '';
	for ( let i = 0; i < bytes.length; i ++ ) binary += String.fromCharCode( bytes[ i ] );

	return btoa( binary ).replace( /\+/g, '-' ).replace( /\//g, '_' ).replace( /=+$/, '' );

}

function base64urlToBytes( str ) {

	const base64 = str.replace( /-/g, '+' ).replace( /_/g, '/' );
	const binary = atob( base64 );
	const bytes = new Uint8Array( binary.length );
	for ( let i = 0; i < binary.length; i ++ ) bytes[ i ] = binary.charCodeAt( i );

	return bytes;

}
